import { render, staticRenderFns } from "./update-button.vue?vue&type=template&id=5439662a&"
import script from "./update-button.vue?vue&type=script&lang=js&"
export * from "./update-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports